<template>
  <Card v-if="show" :title="title" show-status-bar margin="mb-2">
      <DetailField :label="__DICT__.name">
        {{ event.name || (__DICT__.notAvailable || 'Not available') }}
        <router-link v-if="showLink"
                     :to="`/event/${event.reference.split('-')[2]}`"
                     class="btn btn-icon btn-sm btn-ghost-primary ms-2">
          <IconSquareArrowRight />
        </router-link>
      </DetailField>
      <DetailField v-if="event.description && full" :label="__DICT__.description" :value="event.description" />
      <DetailField v-if="full && event.host" :label="__DICT__.host"
                   :value="event.host || (__DICT__.notAvailable || 'Not available')" />
      <DetailField v-if="event.location" :label="__DICT__.passengerView.location">
        <a :href="googleMapsLink(event.location)" target="_blank" class="btn btn-icon btn-ghost-primary btn-sm">
          {{event.locationName}} <span class="me-2"></span> <IconMapPin/>
        </a>
      </DetailField>
      <DetailField v-if="event.startDateTime" :label="__DICT__.startTime" :value="event.startDateTime" />
      <DetailField v-if="event.endDateTime" :label="__DICT__.endTime" :value="event.endDateTime" />
      <DetailField v-if="event.lastEntry" :label="__DICT__.lastEntry" :value="event.lastEntry" />
      <DetailField v-if="full && event.sponsor" :label="__DICT__.sponsor"
                   :value="event.sponsor || (__DICT__.notAvailable || 'Not available')" />
      <DetailField v-if="event.barType" :label="__DICT__.venue"
                   :value="event.barType || (__DICT__.notAvailable || 'Not available')" />
      <DetailField v-if="event.transportInfo && full" :label="__DICT__.transportWord" :value="event.transportInfo" />
      <DetailField v-if="event.clothing && full" :label="__DICT__.clothing || 'Clothing'" :value="event.clothing" />
      <DetailField v-if="event.extraInfo && full" :label="__DICT__.additionalInfo || 'Additional Info'" :value="event.extraInfo" />
      <DetailField v-if="full && event.food !== undefined" :label="__DICT__.events?.eventFood || 'Event Food'"
                   :value="event.food ? (__DICT__.events?.yes || 'Yes') : (__DICT__.events?.no || 'No')" />
      <DetailField v-if="dietary.length > 0 && event.food" :label="__DICT__.passengerView.dietaryPreferences"
                   :value="dietary.length" />
  </Card>
</template>

<script setup>
import {IconSquareArrowRight, IconMapPin} from "@tabler/icons-vue";
import { Card, DetailField } from "@/components/atomic";

const props = defineProps({
  event: {
    type: Object,
    required: true,
    validator: (value) => {
      return value && typeof value === 'object' && 'name' in value
    }
  },
  title: {
    type: String,
    default: __DICT__.eventDetails
  },
  show: {
    type: Boolean,
    default: true
  },
  showLink: {
    type: Boolean,
    default: false
  },
  full: {
    type: Boolean,
    default: false
  },
  dietary: {
    type: Array,
    default: () => []
  }
})

const googleMapsLink = (loc) => {
  try {
    return `https://www.google.com/maps?q=${loc.lat},${loc.lng}`;
  }catch (e) {
    console.error(e)
  }
}
</script>
